import { Injectable } from '@angular/core';
import { OidcOAuthService } from './oidc-oauth.service';

import { Http, Headers, Response,URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { AppSettings } from "./app.settings";
import {ComponentInteractionService} from "./component-interaction.service";

@Injectable()
export class AdminPortalAPIService {
baseUrl : string;
token = "";

constructor(private http: Http, private oidcOauthService : OidcOAuthService,private componentInteractionService: ComponentInteractionService) { 
  this.baseUrl = AppSettings.AdminPortalEndpoint;
  
  if(oidcOauthService.hasValidAccessToken()){
    this.token = oidcOauthService.getAccessToken();
    var a = oidcOauthService.getAccessToken();
  }
  else
    oidcOauthService.logOut();
}
getHeaders(headers:{key:string,value:string}[]=null):Headers{
  
  var headerCollection= new Headers({'Authorization': 'Bearer ' + this.token, "Content-Type":"application/json"});
  if(headers){
    headers.forEach(header => {
      headerCollection.append(header.key,header.value);
    });
  }
  return headerCollection;
}
getQueryParams(queryParams:{key:string,value:string}[]=null):URLSearchParams{
  var search=new URLSearchParams();
  if(queryParams){
    queryParams.forEach(item=>{
      search.set(item.key,item.value);
    })
  }
  return search;
}

get(url:string,headers:{key:string,value:string}[]=null,queryParams:{key:string,value:string}[]=null): Observable<any>{
  this.token = this.oidcOauthService.getAccessToken();
  
  if (url.length > 0 && url[0] === "/")
    url = url.substr(1);
  
  return  this.http
              .get(this.baseUrl + "/" + url, {headers: this.getHeaders(headers), params:this.getQueryParams(queryParams)})
              .map((response:Response) => response.json()).catch((err: Response) => { 
              this.raiseUnAuthorizedTokenError(err);
          return Observable.throw(err);
            });
}

getSolr(url:string): Observable<any>{
  //var headerValue = new Headers({'Authorization': 'Bearer ' + this.token});
  return  this.http
              .get(url)
              .map((response:Response) => response.json())
}
raiseUnAuthorizedTokenError(response:Response)
{
  if(response.status===401)
    {
      this.componentInteractionService.NotifyUnAuthorizedAccessEvent();
    }
} 
post(url:string, data: any): Observable<any>{  
  return this.http
            .post(this.baseUrl + "/" + url, JSON.stringify(data), {headers: this.getHeaders()})
            .map((response:Response)=> response).catch((err: Response) => { 
              this.raiseUnAuthorizedTokenError(err);
          return Observable.throw(err);
            });
}

put(url:string, data:any):Observable<any> {
  
  var putData = JSON.stringify(data);
  return this.http
              .put(this.baseUrl + "/" + url, putData ,{headers: this.getHeaders()})
              .map((response:Response)=> response).catch((err: Response) => { 
              this.raiseUnAuthorizedTokenError(err);
              return Observable.throw(err);
            });  
}

delete(url: string): Observable<any>{ 
  return this.http
             .delete(this.baseUrl + "/" + url, {headers: this.getHeaders()})
             .map((response: Response)=> response).catch((err: Response) => { 
              this.raiseUnAuthorizedTokenError(err);
          return Observable.throw(err);
            });
    }


}
